export const PAGE_TOPPER_EXTENSION_KEY = 'page-topper';
export const PAGE_TOPPER_EXTENSION_TYPE = 'com.atlassian.confluence.page-topper';
export const PAGE_TOPPER_EXTENSION_ANALYTIC_SOURCE = 'pageTopperExtension';
